/**
 * @file upload
 * Created by spu-fe on 2017/10/10.
 */
import Upload from './Upload.js';
export default Upload;